var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatioSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.61942H18.3766M12.0655 0V2.20968V14.9306M12.0655 14.9306H18.3766V7.04164C18.3766 3.55632 15.5508 0.730513 12.0655 0.730513C12.0655 3.1958 12.0655 14.9306 12.0655 14.9306Z",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.131 8.61942H5.75439M12.0655 0V2.20968V14.9306M12.0655 14.9306H5.75439V7.04164C5.75439 3.55632 8.5802 0.730513 12.0655 0.730513C12.0655 3.1958 12.0655 14.9306 12.0655 14.9306Z",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9546 14.9307V22.8196",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7988 14.9307V22.8196",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6436 14.9307V22.8196",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4878 14.9307V22.8196",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 14.9307V22.8196",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17676 14.9307V22.8196",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81006 22.8193H22.3212",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81006 14.9307H22.3212",
    stroke: "#9393B0",
    strokeWidth: 1.57778
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6066,
    height: 23.6066,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatioSvgrepocom);
export default __webpack_public_path__ + "static/media/patio_svgrepo.com.5c37c73d501ecb9c42caa991ba0328de.svg";
export { ForwardRef as ReactComponent };